var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.04865 19.2812L12.9812 16.9062L16.9138 19.3125L15.8839 14.8125L19.3483 11.8125L14.7915 11.4063L12.9812 7.15625L11.171 11.375L6.61419 11.7812L10.0786 14.8125L9.04865 19.2812ZM5.27212 24.5L7.30084 15.7188L0.496826 9.8125L9.48561 9.03125L12.9812 0.75L16.4769 9.03125L25.4657 9.8125L18.6617 15.7188L20.6904 24.5L12.9812 19.8438L5.27212 24.5Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStar);
export default __webpack_public_path__ + "static/media/empty-star.26f8da84636d21d124df991758d62ace.svg";
export { ForwardRef as ReactComponent };